// extracted by mini-css-extract-plugin
module.exports = {"component":"style_component__CYkjw","content":"style_content__DAvKO","message":"style_message__aJQYM"};